import { render, staticRenderFns } from "./systemRelease.vue?vue&type=template&id=d48ab074&scoped=true&"
import script from "./systemRelease.vue?vue&type=script&lang=js&"
export * from "./systemRelease.vue?vue&type=script&lang=js&"
import style0 from "./systemRelease.vue?vue&type=style&index=0&id=d48ab074&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48ab074",
  null
  
)

export default component.exports